import {
  CREATE_NEW_DURATION_MS,
  CREATE_NEW_TOAST_BUTTONS,
  ToastParams,
} from '#models/toast/toast-params.model';

export const TOAST_CONFIGS = {
  documentCreated: (): ToastParams => ({
    header: 'Document Saved',
    message: 'You can now add another document.',
    position: 'middle',
    duration: CREATE_NEW_DURATION_MS,
    buttons: CREATE_NEW_TOAST_BUTTONS,
  }),

  documentUpdated: (): ToastParams => ({
    message: 'Document saved successfully!',
  }),

  documentDeleted: (): ToastParams => ({
    message: 'Document deleted successfully!',
  }),

  memoryCreated: (): ToastParams => ({
    header: 'Memory Saved',
    message: 'You can now add photos and videos to your memory.',
    position: 'middle',
    duration: CREATE_NEW_DURATION_MS,
    buttons: CREATE_NEW_TOAST_BUTTONS,
  }),

  memoryUpdated: (): ToastParams => ({
    message: 'Memory saved successfully!',
  }),

  memoryPublished: (): ToastParams => ({
    message: 'Memory published successfully!',
  }),

  memoryUnpublished: (): ToastParams => ({
    message: 'Memory unpublished successfully!',
  }),

  memoryUrlCopied: (): ToastParams => ({
    message: 'Memory URL copied to clipboard!',
    color: 'light',
  }),

  publishedMemoriesUrlCopied: (): ToastParams => ({
    message: 'Published memories URL copied to clipboard!',
    color: 'light',
  }),

  memoryDeleted: (): ToastParams => ({
    message: 'Memory deleted successfully!',
  }),

  celebrationCreated: (): ToastParams => ({
    message: 'Celebration created successfully!',
  }),

  celebrationUpdated: (): ToastParams => ({
    message: 'Celebration saved successfully!',
  }),

  celebrationCopied: (): ToastParams => ({
    message: 'Celebration copied to clipboard!',
    color: 'light',
  }),

  celebrationDeleted: (): ToastParams => ({
    message: 'Celebration deleted successfully!',
  }),

  familyMemberCreated: (): ToastParams => ({
    header: 'Family Member Saved',
    message: 'You can now add another family member.',
    position: 'middle',
    duration: CREATE_NEW_DURATION_MS,
    buttons: CREATE_NEW_TOAST_BUTTONS,
  }),

  familyMemberUpdated: (): ToastParams => ({
    message: 'Family member saved successfully!',
  }),

  familyMemberDeleted: (): ToastParams => ({
    message: 'Family member deleted successfully!',
  }),

  designatedContactCreatedWithPermissions: (): ToastParams => ({
    message: 'Success! An invite email has been successfully sent.',
  }),

  designatedContactCreatedWithoutPermissions: (): ToastParams => ({
    message: 'Success! The designated contact has been created without permissions.',
  }),

  designatedContactUpdated: (): ToastParams => ({
    message: 'Designated contact saved successfully!',
  }),

  designatedContactDeleted: (): ToastParams => ({
    message: 'Designated contact deleted successfully!',
  }),

  checkInvitations: (): ToastParams => ({
    message: 'No pending invitations found.',
    color: 'light',
  }),

  subscriptionPurchased: (): ToastParams => ({
    message: 'Subscription purchased successfully!',
  }),
} as const;
